import React from "react";
import {
  Card,
  CardContent,
  IconButton,
  MenuItem,
  Option,
  Select,
  Stack,
  Typography,
} from "@mui/joy";
import dayjs from "dayjs";
import { TypeCustomEventItemProps } from "./utils/Types";
import { HeaderProps, ToolbarProps, View } from "react-big-calendar";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";

export const CustomEventItem = ({
  event,
  showDate,
  onClickEventItem,
}: TypeCustomEventItemProps) => {


  return (
    <Stack
      onClick={async (eventClick: any) => {
        if (onClickEventItem) {
          await onClickEventItem({ value: event })
        }
      }}
    >
      {showDate && (
        <Typography level={"body-xs"}>
          {dayjs(event?.start).format("HH:mm") +
            " - " +
            dayjs(event?.end).format("HH:mm")}
        </Typography>
      )}
      <Typography>{event?.title}</Typography>
      {event?.subtitle && (
        <Typography level="body-xs" color="neutral">
          {event?.subtitle}
        </Typography>
      )}
    </Stack>
  );
};

export const CustomHeader = ({ date, label, localizer }: HeaderProps) => {
  return (
    <Stack >
      <Typography level={"body-sm"} sx={{ fontWeight: 600 }}>
        {dayjs(date).format("D")}
      </Typography>
      <Typography>{dayjs(date).format("dddd")}</Typography>
    </Stack>
  );
};

export const CustomToolbar = ({
  date,
  label,
  onNavigate,
  view,
  views,
  onView,
}: ToolbarProps) => {
  const refactorViews = views as string[];

  return (
    <Stack sx={{ position: 'sticky', left: 0 }}>
      <Typography fontWeight={600} color="neutral" level={"body-md"}>
        {label}
      </Typography>
      <Stack direction="row" justifyContent={"space-between"}>
        <Stack direction="row">
          <IconButton size="sm" onClick={() => onNavigate("PREV")}>
            <ArrowBackIos />
          </IconButton>
          <IconButton size="sm" onClick={() => onNavigate("NEXT")}>
            <ArrowForwardIos />
          </IconButton>
        </Stack>
        <Select
          value={view}
          onChange={(event: any, value) => {
            onView(value as View);
          }}
        >
          {refactorViews?.length > 0 &&
            refactorViews?.map((item: string, index: number) => {
              return (
                <Option key={"rbc-menu-item-" + item} value={item}>
                  {item}
                </Option>
              );
            })}
        </Select>
      </Stack>
    </Stack>
  );
};
